import { IShipmentTabConfig } from '../../models/shipments/shipment-tab.interface';

// Each non-heatMap tab maps 1:1 to a MyWorkItemsDetails `tab` value (Order.Public.Messaging.Enums.
// MyWorkItemsDetailsTab) - the flat single-axis selector GetMyWorkItemsDetails actually binds.
export const shipmentTabsConfig: IShipmentTabConfig[] = [
  { key: 'all', labelKey: 'All', tab: 'All' },
  { key: 'pickup', labelKey: 'Pickups', tab: 'Pickup' },
  { key: 'inTransit', labelKey: 'InTransit', tab: 'InTransit' },
  { key: 'delivered', labelKey: 'Deliveries', tab: 'Delivered' },
  { key: 'heatMap', labelKey: 'HeatMap' }
];
